import { path } from 'ramda';
import { isStringOrFalsy } from './TypescriptUtils';

export function parsePathToArray(
  pathToProp?: string,
  obj?: {},
  defaultValue: string | null = null,
): Array<string | {}> {
  const value = pathToProp ? path(pathToProp.split('.'), obj) : defaultValue;

  return Array.isArray(value) ? value : [];
}

export function parsePathToString(
  pathToProp?: string,
  obj?: {},
  defaultValue: string | null | {} = null,
): string {
  const value = pathToProp ? path(pathToProp.split('.'), obj) : defaultValue;

  return isStringOrFalsy(value) ? value : JSON.stringify(value);
}
